import React from 'react';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import PressableArea from '../PressableArea';
import { renderNamedSlot } from 'src/utils/component';
const PageNavbarIcon = ({ Icon, style, ...iconProps }) => {
    const [{ theme }] = useTheme();
    return (React.createElement(PressableArea, { style: style }, renderNamedSlot(Icon, { size: theme.iconSize.md, ...iconProps })));
};
export default PageNavbarIcon;
